import Model from '@/lib/data/Model';
import FormQuestion from './FormQuestion';
import Translation from './Translation';

const SECTION_URL = '/forms/form/section';

class FormSection extends Model {
    static idProperty = 'idField';

    fields = [
        'id',
        'parent_id',
        'form_id',
        'test_id',
        'tag',
        'name',
        'fq_order',
        {
            name: 'children',
            association: {
                type: 'many',
                model: FormSection,
            },
        },
        {
            name: 'questions',
            association: {
                type: 'many',
                model: FormQuestion,
                collectionConfig: {
                    url: '/forms/form/questions',
                    method: 'GET',
                },
            },
        },
        {
            name: 'translation',
            association: {
                type: 'one',
                model: Translation,
            },
        },
        'is_repeatable',
        'form_ques_data_group_id', // not persistent
        {
            name: 'visible_in_shared_mode',
            defaultValue: true,
        },
        {
            name: 'default_visibility',
            defaultValue: true,
        },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    get cascaderChildren() {
        return this.children.length === 0 ? null : this.children;
    }

    get idField() {
        if (this.form_ques_data_group_id) {
            return this.id + this.form_ques_data_group_id;
        }
        return this.id;
    }

    get isVisibleInSharedMode() {
        return this.visible_in_shared_mode;
    }

    api = [
        {
            name: 'create',
            url: SECTION_URL,
            params: [
                'id',
                'parent_id',
                'form_id',
                'test_id',
                'tag',
                'name',
                'translation',
                'default_visibility',
                'is_repeatable',
            ],
        },
        {
            name: 'update',
            url: SECTION_URL,
            params: [
                'id',
                'parent_id',
                'form_id',
                'test_id',
                'tag',
                'name',
                'translation',
                'default_visibility',
                'is_repeatable',
            ],
        },
        {
            name: 'destroy',
            url: SECTION_URL,
            method: 'DELETE',
        },
    ];
}

export default FormSection;
